<template>
  <div class="section-header">
    <h4 class="headings-h4">{{ title }}</h4>
    <small v-if="subtitle" class="text-body-small">{{ subtitle }}</small>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    }
  }
}
</script>
